import React from 'react'
import ButtonGroup from 'constructicon/button-group'
import ButtonShare from 'constructicon/button-share'

const SocialShare = ({
  facebook,
  twitter,
  google,
  linkedin,
  email
}) => (
  <ButtonGroup>
    {facebook === 'yes' ? <ButtonShare type='facebook' share /> : null}
    {twitter === 'yes' ? <ButtonShare type='twitter' share /> : null}
    {google === 'yes' ? <ButtonShare type='google' share /> : null}
    {linkedin === 'yes' ? <ButtonShare type='linkedin' share /> : null}
    {email === 'yes' ? <ButtonShare type='mail' share /> : null}
  </ButtonGroup>
)

export default SocialShare



// WEBPACK FOOTER //
// ./components/ui/SocialShare/index.js